export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export type HttpHeaders = {
  [key: string]: string
}

export type PathParams = Record<string, string | number>

export type PathQueryValue = string | null | boolean | number | string[] | number[]

export type PathQuery = Record<string, PathQueryValue>
